export default __webpack_public_path__ + "static/media/waitlist-calendar.482b83a6.svg";